// import React from "react";
import { useNavigate } from "react-router";
import { Button, Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { activateTopMenu, sidebarToggle } from "redux/actions";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import styled from "styled-components";
import { resetSamithi_MembersToInit, setSamithi_MembersMessage } from "redux/actions";
import { Samithi_MembersForm } from "./../components/samithi_members/form";
import React, { useEffect, useState } from "react"

const AddButton = styled(Button)`
  @media (max-width: 576px) {
    span.text {
      display: none;
    }
  }
`;
type Props = {
    row?: any;
    hideShowForm: (action) => void;
    handleRowEdit: (row) => void;
    action?: string;
     getData: (page, pageSize, searchKey) => void;
};



const Topbar: React.FC<Props> = ({ hideShowForm, handleRowEdit }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const handleActiveDropdown = (menuName: string) => {
        dispatch(activateTopMenu(menuName))
    }
    const isTopActiveMenu = useSelector((state: RootState) => state.template.topActiveMenu);
    const userProfile = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : undefined;
    const handleLogout = () => {
        localStorage.clear();
        navigate('/admin', { replace: true });
    }

    const handleAddButtonClick = () => {
        dispatch(setSamithi_MembersMessage(''));
        hideShowForm('add');
    }
    const [action, setAction] = useState('');
    const [row, setRow] = useState(undefined);
    function getData(page: any, pageSize: any, searchKey: any): void {
        throw new Error("Function not implemented.");
      }
    
    return (
        
        <Nav className="navbar navbar-expand navbar-light topbar static-top shadow mr-2 "
        style={{ backgroundColor:'#194380'}}>
            <h5 style={{ color: 'white', textAlign : 'center', width: '100%',fontWeight:"bold",fontSize:"18px"}}>
            లోకహితం - జాగరణ మాసపత్రిక, సభ్యత్వ నమోదు 
                </h5>

                {/* Rashtriya Swayamsevak Sangh - Telangana Prant */}

            {/* <button id="sidebarToggleTop" className="btn btn-link text-dark d-md-none rounded-circle mr-3" onClick={() => dispatch(sidebarToggle())}>
                <i className="fa fa-bars"></i>
            </button> */}
                {/* <h6 className="m-0 font-weight-bold" style={{color:"#194380"}}>
                        <AddButton className="btn-icon-split float-right" onClick={handleAddButtonClick}>
                            <span className="icon text-white-50" style={{backgroundColor:"#194380",borderColor:"#194380"}}>
                                <i className="fas fa-add" style={{backgroundColor:"#194380",borderColor:"#194380" }}></i>
                            </span>
                            <span className="text"  style={{backgroundColor:"#194380",borderColor:"5px Solid #194380"}}>Add Member</span>
                        </AddButton></h6> */}
            <li className={isTopActiveMenu === "Profile" ? "nav-item dropdown no-arrow show" : "nav-item dropdown no-arrow"} onClick={() => handleActiveDropdown("Profile")}>
                    <a className="nav-link dropdown-toggle" id="userDropdown" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {/* className="h4 text-gray-900 mb-4" */}
                        <span className="mr-2 d-none d-lg-inline text-gray-600"><>Namasthe, {userProfile ? Object.values(userProfile)[1] : 'NA'}  🙏</></span>
                        <img className="img-profile rounded-circle-white " 
                    src="/icons/person-circle.svg"   style={{ color: 'white' }} 
                    alt="User Icon" />
                    </a>
                    <div className={isTopActiveMenu === "Profile" ? "dropdown-menu dropdown-menu-right shadow animated--grow-in show" : "dropdown-menu dropdown-menu-right shadow animated--grow-in"}
                        aria-labelledby="userDropdown">
                        {/* <Button variant="link" className="dropdown-item">

                            <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                            <>{userProfile ? Object.values(userProfile)[1] : 'NA'}</>

                        </Button> */}
                        {/* <Button variant="link" className="dropdown-item">
                            <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                            Settings
                        </Button>
                        <Button variant="link" className="dropdown-item">
                            <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                            Activity Log
                        </Button> */}
                        <div className="dropdown-divider"></div>
                        <Button variant="link" className="dropdown-item" onClick={handleLogout}>
                            <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                            Logout
                        </Button>
                    </div>
                </li>

            {/* </ul> */}
            {action ? 
            <Samithi_MembersForm hideShowForm={setAction} action={action} row={row} getData={getData}/>
            :""
}

        </Nav>
    );
};

export default Topbar;


